import React, { lazy } from 'react'
import { DEFAULT_GAME_ID, ROUTE_PATHS } from 'constants/index'
import GameAvailabilityGate from 'pages/GameInactivePage/GameAvailabilityGate'

const gatedGame = (gameId, Component) => {
  const GatedGame = (props) => React.createElement(
    GameAvailabilityGate,
    { gameId },
    React.createElement(Component, props)
  )
  return GatedGame
}

const LaunchPage = lazy(() => import('pages/LaunchPage'))
const Holdem = lazy(() => import('games/Holdem'))
const ShortDeck = lazy(() => import('games/shortdeck'))
const Plo4 = lazy(() => import('games/plo4'))
const Plo5 = lazy(() => import('games/plo5'))
const Plo6 = lazy(() => import('games/plo6'))
const TournamentLobbyRedirect = lazy(() => import('pages/TournamentLobbyRedirect'))
const TournamentInfoPage = lazy(() => import('pages/TournamentInfoPage'))
const GameRulesPage = lazy(() => import('pages/GameRulesPage'))
const routesList = [
  {
    path: ROUTE_PATHS.home,
    component: LaunchPage,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.gameRules,
    component: GameRulesPage,
    isPrivate: false,
    isHeader: false,
    isFooter: false
  },
  {
    path: '/holdem-game/:tableId',
    component: gatedGame(DEFAULT_GAME_ID.HOLDEM, Holdem),
    isPrivate: true,
    isHeader: true,
    showFooter: true,
    showGameNameBar: true,
    showLeftSideBar: false,
    showRightSideBar: false
  },
  {
    path: '/plo4-game/:tableId',
    component: gatedGame(DEFAULT_GAME_ID.PLO4, Plo4),
    isPrivate: true,
    isHeader: true,
    showFooter: true,
    showGameNameBar: true,
    showLeftSideBar: false,
    showRightSideBar: false
  },
  {
    path: '/plo5-game/:tableId',
    component: gatedGame(DEFAULT_GAME_ID.PLO5, Plo5),
    isPrivate: true,
    isHeader: true,
    showFooter: true,
    showGameNameBar: true,
    showLeftSideBar: false,
    showRightSideBar: false
  },
  {
    path: '/shortdeck-game/:tableId',
    component: gatedGame(DEFAULT_GAME_ID.SHORT_DECK, ShortDeck),
    isPrivate: true,
    isHeader: true,
    showFooter: true,
    showGameNameBar: true,
    showLeftSideBar: false,
    showRightSideBar: false
  },
  {
    path: '/plo6-game/:tableId',
    component: gatedGame(DEFAULT_GAME_ID.PLO6, Plo6),
    isPrivate: true,
    isHeader: true,
    showFooter: true,
    showGameNameBar: true,
    showLeftSideBar: false,
    showRightSideBar: false
  },
  {
    path: '/tournament-lobby',
    component: TournamentLobbyRedirect,
    isPrivate: false,
    isHeader: true,
    showFooter: true,
    showGameNameBar: true,
    showLeftSideBar: false,
    showRightSideBar: false
  },
  {
    path: ROUTE_PATHS.tournamentInfo,
    component: TournamentInfoPage,
    isPrivate: false,
    isHeader: true,
    showFooter: true,
    showGameNameBar: true,
    showLeftSideBar: false,
    showRightSideBar: false
  }
]

export default routesList
